import { Badge } from '@/components/tamagui';
import type { RiskLevel, SizeVariant } from '@/lib/theme-config';

interface RiskBadgeProps {
  level: RiskLevel;
  className?: string;
  size?: SizeVariant;
}

/**
 * Risk Badge Component
 * Displays risk level with traffic light color coding
 */
const RiskBadge = ({ level }: RiskBadgeProps) => {
  return <Badge variant="risk" level={level} />;
};

export default RiskBadge;
